module.exports = __webpack_public_path__ + "assets/ab06741faecad8c9448cd85e41b0d16d.png";